document.addEventListener("DOMContentLoaded", initReviewSliders);
document.addEventListener("shopify:section:load", initReviewSliders);

function initReviewSliders() {

  document.querySelectorAll(".review-section").forEach(function(section){

    const track = section.querySelector(".review-track");
    if(!track) return;

    const cards = section.querySelectorAll(".review-card");
    const prevBtns = section.querySelectorAll(".review-prev");
    const nextBtns = section.querySelectorAll(".review-next");

    let index = 0;
    let isDragging = false;
    let startX = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;

    function getVisibleCards(){
      return window.innerWidth <= 768 ? 1 : 4;
    }

    function getCardWidth(){
      const style = window.getComputedStyle(track);
      const gap = parseInt(style.columnGap || style.gap || 0);
      return cards[0].offsetWidth + gap;
    }

    function updateSlider(){

      const visible = getVisibleCards();
      const maxIndex = Math.max(cards.length - visible, 0);

      if(cards.length <= visible){
        track.style.transform = "translateX(0px)";
        prevBtns.forEach(btn => btn.style.display = "none");
        nextBtns.forEach(btn => btn.style.display = "none");
        return;
      }

      prevBtns.forEach(btn => btn.style.display = "flex");
      nextBtns.forEach(btn => btn.style.display = "flex");

      index = Math.max(0, Math.min(index, maxIndex));

      const cardWidth = getCardWidth();
      currentTranslate = -(index * cardWidth);
      prevTranslate = currentTranslate;

      track.style.transition = "transform 0.3s ease";
      track.style.transform = `translateX(${currentTranslate}px)`;
    }

    // BUTTONS
    prevBtns.forEach(function(btn){
      btn.addEventListener("click", function(){
        index--;
        updateSlider();
      });
    });

    nextBtns.forEach(function(btn){
      btn.addEventListener("click", function(){
        index++;
        updateSlider();
      });
    });

    // ------------------------
    // DRAG FUNCTIONALITY
    // ------------------------

    function touchStart(event){
      isDragging = true;
      startX = getPositionX(event);
      track.style.transition = "none";
    }

    function touchMove(event){
      if(!isDragging) return;

      const currentPosition = getPositionX(event);
      const diff = currentPosition - startX;
      currentTranslate = prevTranslate + diff;

      track.style.transform = `translateX(${currentTranslate}px)`;
    }

    function touchEnd(){
      if(!isDragging) return;
      isDragging = false;

      const movedBy = currentTranslate - prevTranslate;
      const cardWidth = getCardWidth();

      if(movedBy < -50){
        index++;
      }

      if(movedBy > 50){
        index--;
      }

      updateSlider();
    }

    function getPositionX(event){
      return event.type.includes("mouse")
        ? event.pageX
        : event.touches[0].clientX;
    }

    // Mouse Events
    track.addEventListener("mousedown", touchStart);
    track.addEventListener("mousemove", touchMove);
    track.addEventListener("mouseup", touchEnd);
    track.addEventListener("mouseleave", touchEnd);

    // Touch Events
    track.addEventListener("touchstart", touchStart, { passive: true });
    track.addEventListener("touchmove", touchMove, { passive: true });
    track.addEventListener("touchend", touchEnd);

    window.addEventListener("resize", function(){
      index = 0;
      updateSlider();
    });
    updateSlider();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const targetSection = document.querySelector('.product__info-wrapper');
  if (!targetSection) return;
  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          document.body.classList.add('pdp-sticky-show');
        } else {
          document.body.classList.remove('pdp-sticky-show');
        }
      });
    },
    {
      threshold: 0,
    }
  );

  observer.observe(targetSection);

  //sticky ATC submit
  document.querySelectorAll(".sticky-add-cart").forEach(function (stickyBtn) {
    stickyBtn.addEventListener("click", function (e) {
      e.preventDefault();

      const productSubmitBtn = document.querySelector(".product-form__submit");
      const spinner = stickyBtn.querySelector(".loading__spinner");
      if (spinner) {
        spinner.classList.remove("hidden");
      }
      if (productSubmitBtn) {
        productSubmitBtn.click();
      }
      setTimeout(function () {
        if (spinner) {
          spinner.classList.add("hidden");
        }
      }, 1000);
    });
  });

    document.querySelectorAll('.benefits-header').forEach(function (header) {
      header.addEventListener('click', function () {
        const accordion = this.closest('.benefits-accordion');

        accordion.classList.toggle('active');
      });
    });

  const boxes = document.querySelectorAll('.qty-box');
  boxes.forEach((box) => {
    box.addEventListener('click', function () {
      boxes.forEach((b) => b.classList.remove('active'));
      this.classList.add('active');

      const boxTitle = this.querySelector('.qty-inner h4').textContent;
      const stickyTitleWrapper = document.querySelector('.sticky-product-variant');
      if (stickyTitleWrapper && boxTitle)  {
        stickyTitleWrapper.textContent = boxTitle;
      }
      
      const boxPrice = this.querySelector('.qty-inner .price .new').textContent;
      const stickyPrice = document.querySelector('.sticky-product-right .producrt-price-wrapper');
      if (stickyPrice && boxPrice) {
        stickyPrice.textContent = boxPrice;
      }

      const buyButtons = document.querySelectorAll('.product-form .product-form__submit');
      buyButtons.forEach(button => {
        const priceInner = button.querySelector('.price-item.price-item--regular');
        priceInner.textContent = boxPrice;
      })

      // Quantité toujours à 1 — on switch la variante, pas le multiplicateur
      const quantityWrapper = document.querySelector('input[name="quantity"]');
      if (quantityWrapper) quantityWrapper.value = 1;

      // Swap l'ID de variante dans tous les product forms de la page
      const variantId = this.dataset.variantId;
      if (variantId) {
        document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(input => {
          input.value = variantId;
        });
      }
    });
  });

  // Cart line variant switch: swap the variant of a cart line via /cart/update.js
  // then refresh the cart drawer in-place (no page reload, drawer stays open).
  //
  // IMPORTANT: capture-phase listener + stopImmediatePropagation. Le thème a un
  // <cart-drawer-items> qui écoute 'change' en phase bubble et traite la valeur
  // du <select> comme une quantité. Sans intercepter en capture, le thème fait
  // un /cart/change.js avec quantity=<variantId> (un gros nombre) et affiche
  // "Une erreur est survenue lors de l'actualisation de votre panier".
  document.addEventListener('change', function (event) {
    const select = event.target.closest && event.target.closest('.cart-drawer__variant-switch');
    if (!select) return;
    event.stopImmediatePropagation();

    const oldVariantId = select.dataset.currentVariantId;
    const newVariantId = select.value;
    if (!oldVariantId || !newVariantId || oldVariantId === newVariantId) return;

    select.disabled = true;

    const cartDrawer = document.querySelector('cart-drawer');
    const sectionsToRender = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
      ? cartDrawer.getSectionsToRender().map((s) => s.id)
      : ['cart-drawer', 'cart-icon-bubble'];

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        updates: { [oldVariantId]: 0, [newVariantId]: 1 },
        sections: sectionsToRender,
        sections_url: window.location.pathname
      })
    })
    .then((r) => r.json())
    .then((parsedState) => {
      if (parsedState && parsedState.sections && cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsedState);
      } else {
        window.location.reload();
      }
    })
    .catch((err) => {
      console.error('variant switch failed', err);
      select.disabled = false;
    });
  }, true);
});